import React from "react";
import { Link } from "react-router-dom";

const AdminCollections: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold text-zinc-900 dark:text-zinc-100 mb-6">
        Admin – Collections
      </h1>
      <Link
        to="/admin"
        className="text-cyan-600 dark:text-cyan-400 hover:underline"
      >
        ← Back to Admin
      </Link>
    </div>
  );
};

export default AdminCollections;
